// Handles the upload modal's file selection: drag-and-drop or click-to-browse,
// a file chip (name + size + "Ready"), and enabling the Upload button once a file
// is present. Submission itself is a plain multipart form POST — this controller
// only manages the client-side file state.

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "dropZone", "chip", "fileName", "fileSize", "submit"]

  browse() {
    this.inputTarget.click()
  }

  fileChosen() {
    const file = this.inputTarget.files[0]
    if (file) this.showChip(file); else this.reset()
  }

  dragover(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add("border-purple-500")
  }

  dragleave() {
    this.dropZoneTarget.classList.remove("border-purple-500")
  }

  drop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove("border-purple-500")
    const file = event.dataTransfer.files[0]
    if (!file) return
    this.inputTarget.files = event.dataTransfer.files
    this.showChip(file)
  }

  removeFile(event) {
    event.preventDefault()
    this.reset()
  }

  cancel() {
    this.reset()
    this.element.close()
  }

  // --- private ---

  showChip(file) {
    this.fileNameTarget.textContent = file.name
    this.fileSizeTarget.textContent = ` (${this.humanSize(file.size)})`
    this.chipTarget.classList.remove("hidden")
    this.enableSubmit(true)
  }

  reset() {
    this.inputTarget.value = ""
    this.chipTarget.classList.add("hidden")
    this.enableSubmit(false)
  }

  // Tailwind 1.7.6 has no disabled: variant, so the dim is driven here (gotcha #44).
  enableSubmit(enabled) {
    this.submitTarget.disabled = !enabled
    this.submitTarget.style.opacity = enabled ? "1" : "0.5"
    this.submitTarget.style.cursor = enabled ? "pointer" : "not-allowed"
  }

  humanSize(bytes) {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }
}
